// extracted by mini-css-extract-plugin
module.exports = {"hero":"style_hero__A_Z22"};